module.exports = __webpack_public_path__ + "static/media/follow-up.1dd9fc62.jpg";